import { useEffect, useState } from "react";
import api from "../api";

const KIND_IT = {
  risposta: "Risposta", email: "Email", inoltro: "Inoltro", whatsapp: "WhatsApp", campagna: "Campagna",
  "f24-avviso": "Avviso F24", "f24-sollecito": "Sollecito F24", "sollecito-f24": "SMS sollecito F24",
  "promemoria-appuntamento": "Promemoria appuntamento", "sms-manuale": "SMS manuale", sms: "SMS",
  "richiesta-recensione": "Richiesta recensione Google",
  programmata: "Email programmata",
};
const kindLabel = (k) => {
  if (!k) return "Email";
  if (k.startsWith("funnel-lez-")) return `Funnel · Lezione ${k.replace("funnel-lez-", "")}`;
  return KIND_IT[k] || k;
};
const CHANNEL_IT = { email: "Email", sms: "📱 SMS", whatsapp: "WhatsApp" };
const toStr = (to) => (Array.isArray(to) ? to.join(", ") : (to || ""));

export default function SentComms({ params, testid = "sent-comms" }) {
  const [list, setList] = useState(null);
  const [channel, setChannel] = useState("");

  useEffect(() => {
    api.get(`/emails/sent?limit=100&${params}`).then((r) => setList(r.data || [])).catch(() => setList([]));
  }, [params]);

  const filtered = (list || []).filter((m) => !channel || (m.channel || "email") === channel);

  return (
    <div className="panel" data-testid={testid}>
      <div className="toolbar">
        <h3 style={{ margin: 0 }}>Comunicazioni inviate dallo Studio</h3>
        <div className="spacer" />
        <select value={channel} onChange={(e) => setChannel(e.target.value)} data-testid={`${testid}-channel`} style={{ maxWidth: 160 }}>
          <option value="">Tutti i canali</option>
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
        </select>
        <span className="muted" data-testid={`${testid}-count`}>{filtered.length}</span>
      </div>
      {list === null ? <p className="muted">Caricamento…</p> : filtered.length === 0 ? (
        <p className="muted" data-testid={`${testid}-empty`}>Nessuna comunicazione inviata a questo contatto.</p>
      ) : (
        <div style={{ maxHeight: 320, overflowY: "auto" }}>
          <table data-testid={`${testid}-table`}>
            <thead><tr><th>Data</th><th>Canale</th><th>Destinatario</th><th>Oggetto / testo</th><th>Tipo</th></tr></thead>
            <tbody>
              {filtered.map((m) => (
                <tr key={m.id} data-testid={`${testid}-row-${m.id}`}>
                  <td className="muted" style={{ whiteSpace: "nowrap" }}>{m.sent_at ? new Date(m.sent_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{CHANNEL_IT[m.channel || "email"] || "Email"}</td>
                  <td>{toStr(m.to)}</td>
                  <td>{m.subject || <span className="muted">(senza oggetto)</span>}</td>
                  <td className="muted" style={{ whiteSpace: "nowrap" }}>{kindLabel(m.kind)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
